import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";

const selectStyle = {
  height: "40px",
  minWidth: "140px", 
  borderRadius: "20px",
  backgroundColor: "#fff",
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "#334155",

  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    height: "40px !important",
    padding: "0 38px 0 16px !important",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(148,163,184,0.35)",
  },

  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#3b82f6",
  },

  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2563eb",
  },

  "& .MuiSelect-icon": {
    color: "#64748b",
    right: 12,
  },

  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(148,163,184,0.2)",
  },
};

const menuProps = {
  PaperProps: {
    elevation: 0,
    sx: {
      mt: 1,
      maxHeight: 320,
      borderRadius: "14px",
      border: "1px solid rgba(148, 163, 184, 0.2)",
      boxShadow: "0px 4px 20px rgba(15, 23, 42, 0.08)",

      "& .MuiMenu-list": {
        padding: "6px",
      },

      "& .MuiMenuItem-root": {
        minHeight: "36px",
        borderRadius: "10px",
        fontSize: "0.85rem",

        "&:hover": {
          backgroundColor: "#eff6ff",
        },

        "&.Mui-selected": {
          backgroundColor: "#dbeafe",
        },
      },
    },
  },
};

interface Option {
  value: string;
  label: string;
}

interface StyledSelectProps {
  value: any;
  onChange: (event: any) => void;
  options: Option[];
  placeholder?: string;
  multiple?: boolean;
  renderValue?: (value: any) => React.ReactNode;
  loading?: boolean; 
}

export default function StyledSelect({
  value,
  onChange,
  options,
  placeholder = "Select",
  multiple = false,
  renderValue,
  loading = false, 
}: StyledSelectProps) {
  
  const safeValue = value !== undefined && value !== null ? value : (multiple ? [] : "");

  return (
    <Select
      multiple={multiple}
      value={safeValue}
      onChange={onChange}
      displayEmpty
      disabled={loading} 
      input={<OutlinedInput />}
      sx={selectStyle}
      MenuProps={menuProps}
      renderValue={
        loading 
          ? () => <em style={{ color: "#94a3b8", fontStyle: "normal" }}>Loading...</em>
          : renderValue ??
            ((selected) => {
              if (multiple) {
                if (!selected || selected.length === 0)
                  return (
                    <em style={{ color: "#94a3b8", fontStyle: "normal" }}>
                      {placeholder}
                    </em>
                  );

                return `${selected.length} Selected`;
              }

              if (selected === "" || selected == null) {
                return (
                  <em style={{ color: "#94a3b8", fontStyle: "normal" }}>
                    {placeholder}
                  </em>
                );
              }

              return (
                options.find((x) => x.value === selected)?.label ?? (
                  <em style={{ color: "#94a3b8", fontStyle: "normal" }}>
                    {placeholder}
                  </em>
                )
              );
            })
      }
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {multiple && (
            <Checkbox checked={safeValue.includes(option.value)} size="small" />
          )}

          <ListItemText
            primary={option.label}
            primaryTypographyProps={{
              fontSize: "0.85rem",
              fontWeight: 500,
            }}
          />
        </MenuItem>
      ))}
    </Select>
  );
}